import { Route, Routes } from "react-router-dom";
import Header from "./Components/Layout/Header/Header";
import Login from "./Components/Layout/Auth/Login";
import Sidebar from "./Components/Snippets/Sidebar";
import CMSUserTable from "./Components/Layout/CMSUserManagement/CMSUserTable";
import { Toaster } from "react-hot-toast";
import ArbitrationTable from "./Components/Layout/ArbitrationManagement/ArbitrationTable";
import RolesTable from "./Components/Layout/RoleManagement/RolesTable";
import CustomerTable from "./Components/Layout/CustomerManagement/CustomerTable";
import PaymentTable from "./Components/Layout/PaymentRevenue/PaymentTable";
import OrdersTable from "./Components/Layout/Orders/OrdersTable";
import Unauthorized from "./Components/Layout/Auth/Unauthorized";
import ProtectedRoute from "./Components/ProtectedRoute";
import { createContext, useReducer } from "react";
import { initialState, reducer } from "./Redux-reducer/RoleManage";
import Efiling from "./Components/Layout/eFiling/Efiling";
import Dashboard from "./Components/Layout/Dashboard/Dashboard";
import ArbitrationCaseDetails from "./Components/Layout/ArbitrationManagement/ArbitrationCaseDetail";
import TicketList from "./Components/Layout/Ticket/TicketList";
import WhatsAppCampaign from "./Components/Layout/Campaign/WhatsappCampaign";
import EmailCampaign from "./Components/Layout/Campaign/EmailCampaign";

export const UserContext = createContext();

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <div className="bg-bgclr4 h-screen">
      <UserContext.Provider value={{ state, dispatch }}>
        <Routes>
          {/* <Route path="/" element={<Login />} /> */}
          <Route
            path="/*"
            element={
              <>
                <Header />
                <Routes>
                  <Route index element={<Login />} />
                  <Route
                    path="/dashboard/*"
                    element={
                      <>
                        <Sidebar />
                        <Routes>
                          {/* Dashboard Index */}
                          <Route path="home" element={<Dashboard />} />
                          {/* <Route 
                          path="/dashboard/home"
                          element={
                           <ProtectedRoute requiredPermissions={["dashboard"]}>
                            <Dashboard />
                           </ProtectedRoute>
                          } /> */}

                          {/* permission cms_roles -> CMS User Management */}
                          <Route
                            path="/manageUser"
                            element={
                              <ProtectedRoute
                                requiredPermissions={["cms_roles"]}
                              >
                                <CMSUserTable />
                              </ProtectedRoute>
                            }
                          />
                          {/* permission roles -> Role Management */}
                          <Route
                            path="/manageRole"
                            element={
                              <ProtectedRoute requiredPermissions={["roles"]}>
                                <RolesTable />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/efiling"
                            element={
                              <ProtectedRoute requiredPermissions={["efiling"]}>
                                <Efiling />
                              </ProtectedRoute>
                            }
                          />

                          <Route
                            path="/TicketList"
                            element={
                              <ProtectedRoute requiredPermissions={["TICKET"]}>
                                <TicketList />
                              </ProtectedRoute>
                            }
                          />

                          <Route
                            path="/manageCustomer"
                            element={
                              <ProtectedRoute
                                requiredPermissions={["user", "organization"]}
                              >
                                <CustomerTable />
                              </ProtectedRoute>
                            }
                          />
                          {/* permission arbitration -> Arbitration Management */}
                          <Route
                            path="/mngArbi"
                            element={
                              <ProtectedRoute
                                requiredPermissions={["commence"]}
                              >
                                <ArbitrationTable />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/whatsappCampaign"
                            element={
                              <ProtectedRoute
                                requiredPermissions={["notification_service"]}
                              >
                                <WhatsAppCampaign />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/EmailCampaign"
                            element={
                              <ProtectedRoute
                                requiredPermissions={["notification_service"]}
                              >
                                <EmailCampaign />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/case-details/:caseId"
                            element={<ArbitrationCaseDetails />}
                          />
                          {/* permission order -> Orders */}
                          <Route
                            path="/orders"
                            element={
                              <ProtectedRoute requiredPermissions={["order"]}>
                                <OrdersTable />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/paymentManage"
                            element={
                              <ProtectedRoute requiredPermissions={["payment"]}>
                                <PaymentTable />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/unauthorized"
                            element={
                              <ProtectedRoute>
                                <Unauthorized />
                              </ProtectedRoute>
                            }
                          />
                        </Routes>
                      </>
                    }
                  />
                </Routes>
              </>
            }
          />
        </Routes>
      </UserContext.Provider>
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: "",
          duration: 5000,
          style: {
            marginTop: "70px",
          },
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
    </div>
  );
}

export default App;
